import React, { FC, useContext } from 'react';
import { FeatureToggleContext, FeatureStatus } from '../context/FeatureToggleContext';
import { PageSpinner } from '@td-client-frontend/common';
import { useFeatureToggleStatus } from '../hooks/useFeatureToggleStatus';

interface Props {
  featureName: string;
  active: () => React.ReactElement;
  inactive: () => React.ReactElement;
}

export const FeatureToggle: FC<Props> = ({ featureName, active, inactive }: Props) => {
  const { features, handleSetFeature } = useContext(FeatureToggleContext);
  const { isLoading } = useFeatureToggleStatus({ featureName, enabled: !features[featureName], cb: handleSetFeature });

  if (isLoading) {
    return <PageSpinner />;
  }

  return features[featureName] === FeatureStatus.ACTIVE ? active() : inactive();
};
